export interface TenantConfig {
  default: string
  domains: Record<string, string>
  wildcardDomains?: string[]
  cookie?: string
}

export function inferTenantFromHost(host: string | undefined, tenantsConfig: Partial<TenantConfig> = {}): string | undefined {
  if (!host) return undefined
  const normalizedHost = host.toLowerCase()

  // Whitelabel
  const domainMap = tenantsConfig.domains || {}
  if (domainMap[normalizedHost]) return domainMap[normalizedHost]

  // Wildcards
  const wildcardDomains: string[] = tenantsConfig.wildcardDomains || []
  for (const wildcard of wildcardDomains) {
    if (normalizedHost.endsWith(wildcard)) {
      const subdomain = normalizedHost.slice(0, normalizedHost.length - wildcard.length)
      if (subdomain) return subdomain.split('.')[0]
    }
  }
  return undefined
}
